import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { doc, onSnapshot } from "firebase/firestore";

export function useInstance(env, client, id) {
  const [loadedInstance, setLoadedInstance] = useState(false);
  const [instance, setInstance] = useState(null);

  useEffect(() => {
    setLoadedInstance(false);
    if (!client || !id) {
      setLoadedInstance(true);
      return;
    }
    let ref = doc(db, "kiosk", env, "client", client, "instances", id);
    
    const unsub = onSnapshot(ref, (doc) => {
        const data = {id: doc.id, ...doc.data()};
        setInstance(data);
        setLoadedInstance(true);
    });

    return () => unsub();
  }, [env, client, id]);

  return {loadedInstance, instance};
}